// test145
(145 && 0);
